import { MEDIA_LIBRARY_EVENT_PREFIX } from '../CreativeStudio/creativeStudioEventsPrefix';
import { GalleryItemDropdown } from '../GalleryItemDropdown/GalleryItemDropdown';
import { GALLERY_ITEM_DROPDOWN_OPTION_CONFIGS } from '../GalleryItemDropdown/GalleryItemDropdownOptions';

const options = [
    GALLERY_ITEM_DROPDOWN_OPTION_CONFIGS.REPLACE_BACKGROUND,
    GALLERY_ITEM_DROPDOWN_OPTION_CONFIGS.IMAGE_VARIATIONS,
    GALLERY_ITEM_DROPDOWN_OPTION_CONFIGS.CREATE_MOTION_ADS,
    GALLERY_ITEM_DROPDOWN_OPTION_CONFIGS.EDIT_FALLBACK_IMAGE,
];

export const MediaLibraryGalleryItemDropdown = props => {
    return <GalleryItemDropdown options={options} eventsLocationPrefix={MEDIA_LIBRARY_EVENT_PREFIX} {...props} />;
};
